<template>
  <transition name="showHeader">
    <a-layout-header v-if="visible"
      :class="[fixedHeader && 'ant-header-fixedHeader', sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed', ]"
      :style="{ padding: '0' }">
      <div v-if="mode === 'sidemenu'"
        class="header"
        :class="[{fbh:device !== 'mobile'}]">
        <a-icon v-if="device==='mobile'"
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="toggle" />
        <a-icon v-else
          class="trigger"
          :type="collapsed ? 'menu-fold' : 'menu-unfold'"
          @click="toggle" />
        <logo :showTitle="false"
          v-if="device !== 'mobile'" />
        <user-nav v-if="device==='desktop'"
          @click="filterMenu"
          :current="navId"
          :navs="navs"></user-nav>
        <user-menu @changeColor="changeColor"
          :primaryColor="primaryColor"></user-menu>
      </div>
      <div v-else
        :class="['top-nav-header-index', theme]">
        <div class="header-index-wide">
          <div class="header-index-left">
            <logo class="top-nav-header"
              :show-title="device !== 'mobile'" />
            <user-nav v-if="navMenu"
              @click="filterMenu"
              :current="navId"
              :navs="navs"></user-nav>
            <template v-else>
              <s-menu v-if="device !== 'mobile'"
                mode="horizontal"
                :menu="menus"
                :normalMenu="normalMenus"
                :theme="theme" />
              <a-icon v-else
                class="trigger"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="toggle" />
            </template>
          </div>
          <user-menu class="header-index-right"
            @changeColor="changeColor"
            :primaryColor="primaryColor"></user-menu>
        </div>
      </div>
      <user-nav v-if="device!=='desktop'"
        @click="filterMenu"
        :current="navId"
        :navs="navs"></user-nav>
    </a-layout-header>
  </transition>
</template>

<script>
import { mixin } from '@/utils/mixin';
import UserMenu from '../tools/UserMenu';
import UserNav from '../tools/UserNav';
import SMenu from '../Menu';
import Logo from '../tools/Logo';

export default {
  name: 'GlobalHeader',
  components: {
    UserMenu,
    UserNav,
    SMenu,
    Logo,
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu',
    },
    menus: {
      type: Array,
      required: true,
    },
    navId: {
      type: Array,
      default: () => [],
    },
    navs: {
      type: Array,
      default: () => [],
      required: false,
    },
    // 无树状普通数组菜单数据
    normalMenus: {
      type: Array,
      default: () => [],
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    device: {
      type: String,
      required: false,
      default: 'desktop',
    },
  },
  data() {
    return {
      visible: true,
      oldScrollTop: 0,
    };
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  methods: {
    handleScroll() {
      if (!this.autoHideHeader) {
        return;
      }

      const scrollTop = document.body.scrollTop + document.documentElement.scrollTop;
      if (!this.ticking) {
        this.ticking = true;
        requestAnimationFrame(() => {
          if (this.oldScrollTop > scrollTop) {
            this.visible = true;
          } else if (scrollTop > 300 && this.visible) {
            this.visible = false;
          } else if (scrollTop < 300 && !this.visible) {
            this.visible = true;
          }
          this.oldScrollTop = scrollTop;
          this.ticking = false;
        });
      }
    },
    toggle() {
      this.$emit('toggle');
    },
    filterMenu(nav) {
      this.$emit('filterMenu', nav);
    },
    changeColor(color) {
      this.$emit('changeColor', color);
    },
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll, true);
  },
};
</script>

<style lang="less">
.header-animat {
  position: relative;
  z-index: 105;
}
.showHeader-enter-active {
  transition: all 0.25s ease;
}
.showHeader-leave-active {
  transition: all 0.5s ease;
}
.showHeader-enter,
.showHeader-leave-to {
  opacity: 0;
}
.logo {
  // width: 112px;
  padding: 0 8px;
  margin-right: 36px;
  text-align: center;
  .ant-divider-vertical {
    margin: 0 16px;
  }
}
</style>
